import type { MailboxCollectorMappingAddon } from 'owa-analytics-types';
import type MailboxInfo from 'owa-client-types/lib/MailboxInfo';
import { getAnalyticsAddon } from 'owa-analytics-addons';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { sendConfigToWorkers } from 'owa-worker-config-sync-send';
import { trace } from 'owa-trace';

export async function syncMailboxCollectorUrlMapping(
    collectorUrl: string | undefined,
    mailboxInfo: MailboxInfo
): Promise<void> {
    if (!collectorUrl) {
        trace.warn(
            `[CollectorURL] No collectorUrl found for mailbox: ${mailboxInfo.mailboxSmtpAddress}`,
            'analytics'
        );
        return;
    }

    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);

    trace.info(
        `[CollectorURL] Syncing collectorUrl mapping for accountKey: ${accountKey}, collectorUrl: ${collectorUrl}`,
        'analytics'
    );

    // First, sync it on the main thread
    const addon = await getAnalyticsAddon<MailboxCollectorMappingAddon>(
        'MailboxCollectorMapping'
    )?.executeWhenReadyAsync();
    addon?.setMailboxCollectorUrlMapping(accountKey, collectorUrl);

    // Then, send it to the workers
    sendConfigToWorkers('all', 'mailboxCollectorMapping', {
        accountKey,
        collectorUrl,
    });
}
